import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import FeaturedComponent from '../FeaturedComponent';
import getBlogPostsQuery from '../../../../../../graphql/queries/getBlogPosts.graphql';

MostRecentArticle.propTypes = {
  megaMenuClick: PropTypes.func.isRequired,
  tourHighlighted: PropTypes.bool,
  traderResourcesTourMenuClick: PropTypes.bool,
  subItem: PropTypes.bool,
  traderResourcesTourAction: PropTypes.bool,
  menuOpen: PropTypes.bool,
};

function MostRecentArticle ({
  tourHighlighted,
  traderResourcesTourMenuClick,
  megaMenuClick,
  traderResourcesTourAction,
  subItem,
  menuOpen
}) {
  const { loading: blogLoading, data } = useQuery(getBlogPostsQuery, {
    variables: {
      pagination: {
        limit: 1,
      },
      sort: {
        sortBy: 'post_date',
        sortDirection: 'descending',
      },
    },
  });

  const items = get(data, 'blogPosts.items', []);
  const featuredItem = items[0]

  if (!featuredItem) {
    return null;
  }

  return (
    <FeaturedComponent
      exploreMore='Explore Featured Article'
      featuredImage={featuredItem?.metadata?.thumbnailImage?.url}
      featuredItem={featuredItem}
      featuredTitle={featuredItem?.title}
      featuredDate={featuredItem?.postDate}
      featuredSnippet={featuredItem?.definition}
      megaMenuClick={megaMenuClick}
      tourHighlighted={tourHighlighted}
      traderResourcesTourMenuClick={traderResourcesTourMenuClick}
      traderResourcesTourAction={traderResourcesTourAction}
      subItem={subItem}
      menuOpen={menuOpen}
    />
  )
};

export default MostRecentArticle;
